// extracted by mini-css-extract-plugin
export default {"projectContent":"Projects_projectContent__ZHGyh","seeMoreButton":"Projects_seeMoreButton__cgHK+"};